import React from "react";
import {
  Accordion,
  DoubleContent,
  SectionContent,
  Text,
} from "../../../../components";

const leftAccordionList = [
  {
    title: "Chaveiro",
    body: (
      <>
        <Text>
          Se a porta for arrombada, a casa for assaltada ou simplesmente você
          perder as chaves, a gente manda alguém até você
        </Text>
      </>
    ),
  },
  {
    title: "Eletricista",
    body: (
      <>
        <Text>
          A gente envia eletricista para reparar o que for necessário para
          reestabelecer a energia elétrica ou solucionar problemas elétricos,
          dependendo do evento ocorrido.
        </Text>
      </>
    ),
  },
];

const rightAccordionList = [
  {
    title: "Encanador",
    body: (
      <>
        <Text>
          Conte com serviços de hidráulica em casos de emergência ou sinistro
          para reparar vazamento interno que cause ou possa causar um
          alagamento. Lembrando que a assistência será realizada apenas em caso
          de vazamentos aparentes.
        </Text>
      </>
    ),
  },
  {
    title: "Vidraceiro",
    body: (
      <Text>
        Em caso de emergência, enviamos vidraceiro para consertar portas de
        vidro ou janelas externas de vidro. Caso não seja possível a execução do
        serviço será colocado um tapume. Lembrando que essa assistência não
        inclui vidros de blindex, apenas vidros simples.
      </Text>
    ),
  },
];

const AssistenciasHabitacionalTradicional = () => {
  return (
    <>
      <SectionContent>
        <DoubleContent
          leftContent={<Accordion listItems={leftAccordionList} />}
          rightContent={<Accordion listItems={rightAccordionList} />}
        />
      </SectionContent>
    </>
  );
};

export default AssistenciasHabitacionalTradicional;
